import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { StudioProvider } from "@/contexts/StudioContext";
import { TenantBrandingProvider } from "@/contexts/TenantBrandingContext";
import { ModulesProvider, useModules } from "@/contexts/ModulesContext";
import ModuleNotBooked from "@/pages/ModuleNotBooked";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";
import MaintenanceOverlay from "@/components/MaintenanceOverlay";
import GlobalActivityBar from "@/components/GlobalActivityBar";
import SeriesJobsOverlay from "@/components/SeriesJobsOverlay";
import SupportModeBanner from "@/components/SupportModeBanner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import LoginPage from "@/pages/LoginPage";
import MagicLinkPage from "@/pages/MagicLinkPage";
import AppRedirectPage from "@/pages/AppRedirectPage";
import EmailDiagnosticsPage from "@/pages/EmailDiagnosticsPage";
import HolidaysSettingsPage from "@/pages/HolidaysSettingsPage";
import RecoverySettingsPage from "@/pages/RecoverySettingsPage";
import RegisterPage from "@/pages/RegisterPage";
import BusinessRegisterPage from "@/pages/BusinessRegisterPage";
import BranchSelectPage from "@/pages/BranchSelectPage";
import VerifyCustomerPage from "@/pages/VerifyCustomerPage";
import RechnungStatusPage from "@/pages/RechnungStatusPage";
import DashboardLayout from "@/layouts/DashboardLayout";
import DentalChartPage from "@/pages/DentalChartPage";
import DentalRecallPage from "@/pages/DentalRecallPage";
import DentalPerioPage from "@/pages/DentalPerioPage";
import DentalBillingPage from "@/pages/DentalBillingPage";
import DentalEstimatesPage from "@/pages/DentalEstimatesPage";
import DentalTreatmentPlanPage from "@/pages/DentalTreatmentPlanPage";
import PublicEstimatePage from "@/pages/PublicEstimatePage";
import PublicWorkshopApprovalPage from "@/pages/PublicWorkshopApprovalPage";
import PublicWorkshopBooking from "@/pages/PublicWorkshopBooking";
import PublicWorkshopAppointmentPage from "@/pages/PublicWorkshopAppointmentPage";
import WorkshopPage from "@/pages/WorkshopPage";
import SuperAdminApp from "@/pages/superadmin/SuperAdminApp";
import DashboardPage from "@/pages/DashboardPage";
import CustomersPage from "@/pages/CustomersPage";
import AppointmentsPage from "@/pages/AppointmentsPage";
import ServicesPage from "@/pages/ServicesPage";
import CoursesAdminPage from "@/pages/CoursesAdminPage";
import ResourcesPage from "@/pages/ResourcesPage";
import PaymentsPage from "@/pages/PaymentsPage";
import CampaignsPage from "@/pages/CampaignsPage";
import SettingsPage from "@/pages/SettingsPage";
import StaffPage from "@/pages/StaffPage";
import TrainerProfitabilityPage from "@/pages/TrainerProfitabilityPage";
import PayrollDeductionsPage from "@/pages/PayrollDeductionsPage";
import AIUsagePage from "@/pages/AIUsagePage";
import AIBudgetPage from "@/pages/AIBudgetPage";
import SubscriptionPage from "@/pages/SubscriptionPage";
import MyPlanPage from "@/pages/MyPlanPage";
import PlatformInvoicesPage from "@/pages/PlatformInvoicesPage";
import PersonalPage from "@/pages/PersonalPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import InvoicesPage from "@/pages/InvoicesPage";
import BillingAuditPage from "@/pages/BillingAuditPage";
import ProductsPage from "@/pages/ProductsPage";
import BillingPage from "@/pages/BillingPage";
import WhatsAppPage from "@/pages/WhatsAppPage";
import WhatsAppTemplatesPage from "@/pages/WhatsAppTemplatesPage";
import WhatsAppLogsPage from "@/pages/WhatsAppLogsPage";
import MessageLogPage from "@/pages/MessageLogPage";
import GlobalHistoryPage from "@/pages/GlobalHistoryPage";
import CommunicationLogPage from "@/pages/CommunicationLogPage";
import EmailTemplatesPage from "@/pages/EmailTemplatesPage";
import EmailLogsPage from "@/pages/EmailLogsPage";
import IndexStatsPage from "@/pages/IndexStatsPage";
import VendorCredentialsPage from "@/pages/VendorCredentialsPage";
import SendEmailPage from "@/pages/SendEmailPage";
import CommunicationSettingsPage from "@/pages/CommunicationSettingsPage";
import ReferralSourcesSettingsPage from "@/pages/ReferralSourcesSettingsPage";
import AutomationRulesPage from "@/pages/AutomationRulesPage";
import PushConfigsPage from "@/pages/PushConfigsPage";
import PoliciesEditorPage from "@/pages/PoliciesEditorPage";
import FailedReloadsPage from "@/pages/FailedReloadsPage";
import SalesPage from "@/pages/SalesPage";
import StudiosPage from "@/pages/StudiosPage";
import StudioHoursPage from "@/pages/StudioHoursPage";
import StudioMigrationPage from "@/pages/StudioMigrationPage";
import StudioBonusSettingsPage from "@/pages/StudioBonusSettingsPage";
import PublicPolicyPage from "@/pages/PublicPolicyPage";
import RentInvoicesPage from "@/pages/RentInvoicesPage";
import ReportsPage from "@/pages/ReportsPage";
import PublicAnamnesePage from "@/pages/PublicAnamnesePage";
import PublicReschedulePage from "@/pages/PublicReschedulePage";
import CardChoicePage from "@/pages/CardChoicePage";
import CustomerPortal from "@/pages/CustomerPortal";
import GoogleOAuthCallback from "@/pages/GoogleOAuthCallback";
import PublicBooking from "@/pages/PublicBooking";
import SalesLanding from "@/pages/SalesLanding";
import ConsentSignPage from "@/pages/ConsentSignPage";
import OnboardingPage from "@/pages/OnboardingPage";
import SetupWizardPage from "@/pages/SetupWizardPage";import OnboardingStart from "@/pages/OnboardingStart";
import EmployeeOnboardingPage from "@/pages/EmployeeOnboardingPage";
import SetPasswordPage from "@/pages/SetPasswordPage";
import TrainingPage from "@/pages/TrainingPage";
import WODTrainingPage from "@/pages/WODTrainingPage";
import KochbuchPage from "@/pages/KochbuchPage";
import NutritionPage from "@/pages/NutritionPage";
import AdminRecipesPage from "@/pages/AdminRecipesPage";
import ProductReviewsPage from "@/pages/ProductReviewsPage";
import PortalSettingsPage from "@/pages/PortalSettingsPage";
import PortalAIAssistantSettings from "@/pages/PortalAIAssistantSettings";
import PortalAppearanceSettings from "@/pages/PortalAppearanceSettings";
import PortalContentSettings from "@/pages/PortalContentSettings";
import PortalBookingSettings from "@/pages/PortalBookingSettings";
import EPostSettings from "@/pages/EPostSettings";
import PortalEmbedSettings from "@/pages/PortalEmbedSettings";
import PortalCategoriesSettings from "@/pages/PortalCategoriesSettings";
import PortalInsuranceSettings from "@/pages/PortalInsuranceSettings";
import TrackingRewardsSettings from "@/pages/TrackingRewardsSettings";
import GoogleOAuthSettingsPage from "@/pages/GoogleOAuthSettingsPage";
import AuditLogPage from "@/pages/AuditLogPage";
import ICloudSyncSettingsPage from "@/pages/ICloudSyncSettingsPage";
import MainSettingsPage from "@/pages/MainSettingsPage";
import SettingsLayout from "@/pages/SettingsLayout";
import SettingsHub from "@/pages/settings/SettingsHub";
import SettingsChangeLogPage from "@/pages/settings/SettingsChangeLogPage";
import PaymentMethodsSettingsPage from "@/pages/PaymentMethodsSettingsPage";
import SumUpSettingsPage from "@/pages/SumUpSettingsPage";
import ErpSettingsPage from "@/pages/ErpSettingsPage";
import CustomerSubscriptionsPage from "@/pages/CustomerSubscriptionsPage";
import PublicSchedulePage from "@/pages/PublicSchedulePage";
import PublicPricingPage from "@/pages/PublicPricingPage";
import WaitlistSettingsPage from "@/pages/WaitlistSettingsPage";
import SpontanBookingPage from "@/pages/SpontanBookingPage";
import WaitlistConfirmPage from "@/pages/WaitlistConfirmPage";
import WaitlistQuickConfirmPage from "@/pages/WaitlistQuickConfirmPage";
import WidgetChatPage from "@/pages/WidgetChatPage";
import WidgetPopup from "@/pages/WidgetPopup";
import WidgetDemo from "@/pages/WidgetDemo";
import MobileAppPage from "@/pages/MobileAppPage";
import HealthDashboardPage from "@/pages/HealthDashboardPage";
import SystemHealthPage from "@/pages/SystemHealthPage";
import FunnelTrackingPage from "@/pages/FunnelTrackingPage";
import TimeTrackingPage from "@/pages/TimeTrackingPage";
import CardExpirySettingsPage from "@/pages/CardExpirySettingsPage";
import PhysioBillingPage from "@/pages/PhysioBillingPage";
import PhysioBillingSettingsPage from "@/pages/PhysioBillingSettingsPage";
import CardsOverviewPage from "@/pages/CardsOverviewPage";
import DensityLearningPage from "@/pages/DensityLearningPage";
import FeedbackAnalyticsPage from "@/pages/FeedbackAnalyticsPage";
import MindbodyIntegrationPage from "@/pages/MindbodyIntegrationPage";
import AdsSettingsPage from "@/pages/AdsSettingsPage";
import LoyaltySettingsPage from "@/pages/LoyaltySettingsPage";
import RewardsAdminPage from "@/pages/RewardsAdminPage";
import SecuritySettingsPage from "@/pages/SecuritySettingsPage";
import CalendarColumnsSettingsPage from "@/pages/CalendarColumnsSettingsPage";
import GoogleBusinessHoursPage from "@/pages/GoogleBusinessHoursPage";
import ReEngagementSettingsPage from "@/pages/ReEngagementSettingsPage";
import DiscountsPage from "@/pages/DiscountsPage";
import WebsiteAnalyticsPage from "@/pages/WebsiteAnalyticsPage";
import MobileHealthPage from "@/pages/MobileHealthPage";
import MobileErrorsPage from "@/pages/MobileErrorsPage";
import DeletedAccountsPage from "@/pages/DeletedAccountsPage";
import MobileStandaloneApp from "@/pages/MobileStandaloneApp";
import PortalAutoLogin from "@/pages/PortalAutoLogin";
import CrmPipelinePage from "@/pages/CrmPipelinePage";
import PublicInterestPage from "@/pages/PublicInterestPage";
import PublicInterestMiniPage from "@/pages/PublicInterestMiniPage";
import PhoneUpdatePage from "@/pages/PhoneUpdatePage";
import AccountDeletionPage from "@/pages/AccountDeletionPage";

const queryClient = new QueryClient();

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

// Role-based route protection - redirects unauthorized users to their allowed page
const RoleProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Superadmin (Plattform-Betreiber) ist ein Superset von admin und
  // darf jede admin-geschützte Route sehen.
  if (user.role === 'superadmin') {
    return children;
  }

  // Check if user's role is in allowed roles
  if (!allowedRoles.includes(user.role)) {
    // Redirect to appropriate page based on role
    if (user.role === 'mieter') {
      return <Navigate to="/resources" replace />;
    } else if (user.role === 'trainer') {
      return <Navigate to="/appointments" replace />;
    } else if (user.role === 'customer') {
      // Iter 326: Kunden landen automatisch im /portal — verhindert das
      // leere Admin-Shell-Erlebnis, wenn ein Kunde sich via /login mit
      // Passwort einloggt.
      return <Navigate to="/portal" replace />;
    } else {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

// Permission-based route protection for trainers with individual permissions
const PermissionProtectedRoute = ({ children, allowedRoles, requiredPermission }) => {
  const { user, loading, hasPermission } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Admins always have access
  if (user.role === 'admin' || user.role === 'superadmin') {
    return children;
  }

  // Check role first
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === 'mieter') {
      return <Navigate to="/resources" replace />;
    } else if (user.role === 'trainer') {
      return <Navigate to="/appointments" replace />;
    } else if (user.role === 'customer') {
      return <Navigate to="/portal" replace />;
    }
    return <Navigate to="/" replace />;
  }

  // For trainers, check specific permission
  if (user.role === 'trainer' && requiredPermission) {
    if (!hasPermission(requiredPermission)) {
      return <Navigate to="/appointments" replace />;
    }
  }

  return children;
};

// Modul-Gating: blendet gesperrte Module aus und zeigt eine freundliche
// "Nicht gebucht"-Seite statt eines Fehlers (greift auch bei Direkt-URL).
// Fail-open: ohne aktives Abo ist jedes Modul freigeschaltet.
const ModuleProtectedRoute = ({ children, module }) => {
  const { isModuleEnabled, isModuleVisible, loading } = useModules();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (!isModuleEnabled(module)) {
    // Sichtbares Modul → Freischalten-Seite; verstecktes Modul → neutrale 404.
    return isModuleVisible(module) ? <ModuleNotBooked module={module} /> : <NotFound />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/vorschau" element={<SalesLanding />} />
      <Route path="/vorschau/:branch" element={<SalesLanding />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/betrieb-registrieren" element={<BusinessRegisterPage />} />
      {/* Öffentliche Branchen-Auswahl — alle Verticals in einer Plattform */}
      <Route path="/branchen" element={<BranchSelectPage />} />
      <Route path="/branches" element={<BranchSelectPage />} />
      {/* Magic-Link Landing — passwortloser Login via Email/WhatsApp */}
      <Route path="/auth/magic" element={<MagicLinkPage />} />
      <Route path="/verify/:token" element={<VerifyCustomerPage />} />
      <Route path="/rechnung-status" element={<RechnungStatusPage />} />
      <Route path="/invoice-status" element={<RechnungStatusPage />} />
      {/* Public policy pages - AGB & Datenschutz */}
      <Route path="/agb" element={<PublicPolicyPage />} />
      <Route path="/datenschutz" element={<PublicPolicyPage />} />
      <Route path="/kochbuch/:token" element={<KochbuchPage />} />
      {/* Public anamnese page - no auth required */}
      <Route path="/anamnese/fill/:token" element={<PublicAnamnesePage />} />
      <Route path="/umbuchen/:token" element={<PublicReschedulePage />} />
      <Route path="/karten-wahl/:token" element={<CardChoicePage />} />
      {/* Public booking page - embeddable, no auth required */}
      <Route path="/buchen" element={<PublicBooking />} />
      <Route path="/buchen/*" element={<PublicBooking />} />
      <Route path="/einverstaendnis/:token" element={<ConsentSignPage />} />
      <Route path="/kv/:token" element={<PublicEstimatePage />} />
      <Route path="/werkstatt-freigabe/:token" element={<PublicWorkshopApprovalPage />} />
      <Route path="/werkstatt-termin/:token" element={<PublicWorkshopAppointmentPage />} />
      <Route path="/werkstatt-buchen" element={<PublicWorkshopBooking />} />
      <Route path="/onboarding/start" element={<OnboardingStart />} />
      <Route path="/onboarding/:token" element={<OnboardingPage />} />
      <Route path="/mitarbeiter-onboarding/:token" element={<EmployeeOnboardingPage />} />
      
      {/* Public Schedule (for iframe embedding) */}
      <Route path="/kursplan" element={<PublicSchedulePage />} />
      <Route path="/schedule" element={<PublicSchedulePage />} />
      {/* Public Pricing (for iframe embedding) */}
      <Route path="/preisliste" element={<PublicPricingPage />} />
      <Route path="/pricing" element={<PublicPricingPage />} />
      {/* Public Interest Form (for iframe embedding, e.g. Rapperswil) */}
      <Route path="/interesse" element={<PublicInterestPage />} />
      <Route path="/interesse/:source" element={<PublicInterestPage />} />
      <Route path="/interesse-mini" element={<PublicInterestMiniPage />} />
      <Route path="/nummer-nachtragen/:token" element={<PhoneUpdatePage />} />
      <Route path="/interesse-mini/:source" element={<PublicInterestMiniPage />} />
      {/* Public account deletion info (Google Play / App Store requirement) */}
      <Route path="/konto-loeschen" element={<AccountDeletionPage />} />
      {/* Spontaneous Booking from Waitlist */}
      <Route path="/spontan-buchen" element={<SpontanBookingPage />} />
      {/* Waitlist Reservation Confirmation (consecutive day) */}
      <Route path="/waitlist-confirm" element={<WaitlistConfirmPage />} />
      {/* One-Click Quick Confirm from Waitlist (no login needed) */}
      <Route path="/waitlist/quick-confirm" element={<WaitlistQuickConfirmPage />} />
      {/* Embeddable Widget Chat */}
      <Route path="/widget/chat" element={<WidgetChatPage />} />
      {/* Embeddable Widget Popup */}
      <Route path="/widget/popup" element={<WidgetPopup />} />
      {/* Widget Demo Page */}
      <Route path="/widget/demo" element={<WidgetDemo />} />
      {/* Password setup page - no auth required */}
      <Route path="/passwort-setzen" element={<SetPasswordPage />} />
      {/* Smart Redirect: WhatsApp/Email "Zur App"-Buttons öffnen die installierte
          StrongFit-App via strongfit:// — Fallback auf /portal nach 1.6s. */}
      <Route path="/app" element={<AppRedirectPage />} />
      <Route path="/app-redirect" element={<AppRedirectPage />} />
      {/* Google OAuth Callback - for custom Google credentials */}
      <Route path="/portal/oauth/callback" element={<GoogleOAuthCallback />} />
      {/* Google OAuth Callback - for custom Google credentials (preferred path) */}
      <Route path="/portal/google/callback" element={<GoogleOAuthCallback />} />

      {/* Standalone Mobile App - public, separate customer auth */}
      <Route path="/mobile" element={<MobileStandaloneApp />} />
      <Route path="/mobile/*" element={<MobileStandaloneApp />} />

      {/* Portal Auto-Login for testing */}
      <Route path="/portal/auto-login" element={<PortalAutoLogin />} />
      {/* Betriebs-Onboarding (Einrichtungs-Assistent) - full-screen, admin */}
      <Route path="/einrichtung" element={<RoleProtectedRoute allowedRoles={['admin']}><SetupWizardPage /></RoleProtectedRoute>} />
      {/* Super-Admin (Plattform-Betreiber) - eigener Bereich, eigenes Layout */}
      <Route path="/superadmin/*" element={<ProtectedRoute><SuperAdminApp /></ProtectedRoute>} />
      {/* Customer Portal - public, separate auth */}
      <Route path="/portal" element={<CustomerPortal />} />
      <Route path="/portal/*" element={<CustomerPortal />} />
      {/* Studio-spezifische Einstiegs-URLs: fit.invictaflow.ch/<studio>/admin|portal|login */}
      <Route path="/:studioSlug/admin" element={<LoginPage />} />
      <Route path="/:studioSlug/login" element={<LoginPage />} />
      <Route path="/:studioSlug/portal" element={<CustomerPortal />} />
      <Route path="/:studioSlug/portal/*" element={<CustomerPortal />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <Routes>
                {/* Admin only routes */}
                <Route path="/" element={<RoleProtectedRoute allowedRoles={['admin']}><DashboardPage /></RoleProtectedRoute>} />
                <Route path="/dashboard" element={<RoleProtectedRoute allowedRoles={['admin']}><DashboardPage /></RoleProtectedRoute>} />
                <Route path="/services" element={<RoleProtectedRoute allowedRoles={['admin']}><ServicesPage /></RoleProtectedRoute>} />
                <Route path="/courses-admin" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="booking"><CoursesAdminPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/admin/recipes" element={<RoleProtectedRoute allowedRoles={['admin']}><AdminRecipesPage /></RoleProtectedRoute>} />
                <Route path="/campaigns" element={<RoleProtectedRoute allowedRoles={['admin']}><CampaignsPage /></RoleProtectedRoute>} />
                <Route path="/admin/ads" element={<RoleProtectedRoute allowedRoles={['admin']}><AdsSettingsPage /></RoleProtectedRoute>} />
                <Route path="/admin/loyalty" element={<RoleProtectedRoute allowedRoles={['admin']}><LoyaltySettingsPage /></RoleProtectedRoute>} />
                <Route path="/admin/rewards" element={<RoleProtectedRoute allowedRoles={['admin']}><RewardsAdminPage /></RoleProtectedRoute>} />
                <Route path="/settings/security" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer', 'staff', 'mieter']}><SecuritySettingsPage /></RoleProtectedRoute>} />
                <Route path="/message-log" element={<RoleProtectedRoute allowedRoles={['admin']}><MessageLogPage /></RoleProtectedRoute>} />
                <Route path="/global-history" element={<RoleProtectedRoute allowedRoles={['admin']}><GlobalHistoryPage /></RoleProtectedRoute>} />
                <Route path="/communication-log" element={<RoleProtectedRoute allowedRoles={['admin']}><CommunicationLogPage /></RoleProtectedRoute>} />
                <Route path="/staff" element={<RoleProtectedRoute allowedRoles={['admin']}><StaffPage /></RoleProtectedRoute>} />
                <Route path="/trainers/:id" element={<RoleProtectedRoute allowedRoles={['admin']}><TrainerProfitabilityPage /></RoleProtectedRoute>} />
                <Route path="/payroll/deductions" element={<RoleProtectedRoute allowedRoles={['admin']}><ModuleProtectedRoute module="payroll"><PayrollDeductionsPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/admin/ai-usage" element={<RoleProtectedRoute allowedRoles={['admin']}><AIUsagePage /></RoleProtectedRoute>} />
                <Route path="/admin/ai-budget" element={<RoleProtectedRoute allowedRoles={['admin']}><AIBudgetPage /></RoleProtectedRoute>} />
                <Route path="/admin/subscription" element={<RoleProtectedRoute allowedRoles={['admin']}><SubscriptionPage /></RoleProtectedRoute>} />
                <Route path="/mein-abo" element={<RoleProtectedRoute allowedRoles={['admin']}><MyPlanPage /></RoleProtectedRoute>} />
                <Route path="/meine-rechnungen" element={<RoleProtectedRoute allowedRoles={['admin']}><PlatformInvoicesPage /></RoleProtectedRoute>} />
                <Route path="/personal" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="payroll"><PersonalPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/products" element={<RoleProtectedRoute allowedRoles={['admin']}><ProductsPage /></RoleProtectedRoute>} />
                <Route path="/whatsapp" element={<RoleProtectedRoute allowedRoles={['admin']}><WhatsAppPage /></RoleProtectedRoute>} />
                <Route path="/whatsapp/templates" element={<RoleProtectedRoute allowedRoles={['admin']}><WhatsAppTemplatesPage /></RoleProtectedRoute>} />
                <Route path="/whatsapp/logs" element={<RoleProtectedRoute allowedRoles={['admin']}><WhatsAppLogsPage /></RoleProtectedRoute>} />
                <Route path="/email/templates" element={<RoleProtectedRoute allowedRoles={['admin']}><EmailTemplatesPage /></RoleProtectedRoute>} />
                <Route path="/email/logs" element={<RoleProtectedRoute allowedRoles={['admin']}><EmailLogsPage /></RoleProtectedRoute>} />
                <Route path="/email/send" element={<RoleProtectedRoute allowedRoles={['admin']}><SendEmailPage /></RoleProtectedRoute>} />
                <Route path="/communication/settings" element={<RoleProtectedRoute allowedRoles={['admin']}><CommunicationSettingsPage /></RoleProtectedRoute>} />
                <Route path="/physio-billing" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="invoicing"><PhysioBillingPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/settings/physio-billing-full" element={<RoleProtectedRoute allowedRoles={['admin']}><PhysioBillingSettingsPage /></RoleProtectedRoute>} />
                <Route path="/admin/density-learning" element={<RoleProtectedRoute allowedRoles={['admin']}><DensityLearningPage /></RoleProtectedRoute>} />
                <Route path="/feedback-analytics" element={<RoleProtectedRoute allowedRoles={['admin']}><FeedbackAnalyticsPage /></RoleProtectedRoute>} />
                <Route path="/admin/integrations/mindbody" element={<RoleProtectedRoute allowedRoles={['admin']}><MindbodyIntegrationPage /></RoleProtectedRoute>} />
                <Route path="/admin/integrations/google-business" element={<RoleProtectedRoute allowedRoles={['admin']}><GoogleBusinessHoursPage /></RoleProtectedRoute>} />
                {/* /settings/email-diagnostics -> jetzt eingebettet im SettingsLayout (/settings/:panelId) */}
                <Route path="/admin/index-stats" element={<RoleProtectedRoute allowedRoles={['admin']}><IndexStatsPage /></RoleProtectedRoute>} />
                <Route path="/admin/vendor-credentials" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><VendorCredentialsPage /></RoleProtectedRoute>} />
                <Route path="/admin/deleted-accounts" element={<RoleProtectedRoute allowedRoles={['admin']}><DeletedAccountsPage /></RoleProtectedRoute>} />
                {/* /settings/holidays -> jetzt eingebettet im SettingsLayout (/settings/:panelId) */}
                <Route path="/settings/recovery" element={<RoleProtectedRoute allowedRoles={['admin']}><RecoverySettingsPage /></RoleProtectedRoute>} />
                <Route path="/discounts" element={<RoleProtectedRoute allowedRoles={['admin']}><DiscountsPage /></RoleProtectedRoute>} />
                <Route path="/website-analytics" element={<RoleProtectedRoute allowedRoles={['admin']}><WebsiteAnalyticsPage /></RoleProtectedRoute>} />
                <Route path="/mobile-health" element={<RoleProtectedRoute allowedRoles={['admin']}><MobileHealthPage /></RoleProtectedRoute>} />
                <Route path="/mobile-errors" element={<RoleProtectedRoute allowedRoles={['admin']}><MobileErrorsPage /></RoleProtectedRoute>} />
                <Route path="/settings/referral-sources-full" element={<RoleProtectedRoute allowedRoles={['admin']}><ReferralSourcesSettingsPage /></RoleProtectedRoute>} />
                <Route path="/automation/rules" element={<RoleProtectedRoute allowedRoles={['admin']}><AutomationRulesPage /></RoleProtectedRoute>} />
                <Route path="/push/configs" element={<RoleProtectedRoute allowedRoles={['admin']}><PushConfigsPage /></RoleProtectedRoute>} />
                <Route path="/waitlist" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="booking"><WaitlistSettingsPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/policies/editor" element={<RoleProtectedRoute allowedRoles={['admin']}><PoliciesEditorPage /></RoleProtectedRoute>} />
                <Route path="/failed-reloads" element={<RoleProtectedRoute allowedRoles={['admin']}><FailedReloadsPage /></RoleProtectedRoute>} />
                <Route path="/studios" element={<RoleProtectedRoute allowedRoles={['admin']}><StudiosPage /></RoleProtectedRoute>} />
                <Route path="/studios/hours" element={<RoleProtectedRoute allowedRoles={['admin']}><StudioHoursPage /></RoleProtectedRoute>} />
                <Route path="/studios/migrate" element={<RoleProtectedRoute allowedRoles={['admin']}><StudioMigrationPage /></RoleProtectedRoute>} />
                <Route path="/studios/bonus" element={<RoleProtectedRoute allowedRoles={['admin']}><StudioBonusSettingsPage /></RoleProtectedRoute>} />
                <Route path="/rent-invoices" element={<RoleProtectedRoute allowedRoles={['admin']}><ModuleProtectedRoute module="invoicing"><RentInvoicesPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/cards-overview" element={<RoleProtectedRoute allowedRoles={['admin']}><ModuleProtectedRoute module="invoicing"><CardsOverviewPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/training" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><TrainingPage /></RoleProtectedRoute>} />
                <Route path="/wod-training" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><WODTrainingPage /></RoleProtectedRoute>} />
                <Route path="/nutrition" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="nutrition"><NutritionPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/product-reviews" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ProductReviewsPage /></RoleProtectedRoute>} />
                
                {/* Portal Settings Routes */}
                <Route path="/portal-settings" element={<RoleProtectedRoute allowedRoles={['admin']}><PortalSettingsPage /></RoleProtectedRoute>} />
                <Route path="/portal-settings/appearance" element={<RoleProtectedRoute allowedRoles={['admin']}><PortalAppearanceSettings /></RoleProtectedRoute>} />
                <Route path="/portal-settings/categories" element={<RoleProtectedRoute allowedRoles={['admin']}><PortalCategoriesSettings /></RoleProtectedRoute>} />
                <Route path="/portal-settings/content" element={<RoleProtectedRoute allowedRoles={['admin']}><PortalContentSettings /></RoleProtectedRoute>} />
                <Route path="/portal-settings/booking" element={<RoleProtectedRoute allowedRoles={['admin']}><PortalBookingSettings /></RoleProtectedRoute>} />
                {/* ePost / Zahlungsarten / SumUp / ERP -> jetzt eingebettet im SettingsLayout (/settings/:panelId) */}
                <Route path="/portal-settings/tracking-rewards" element={<RoleProtectedRoute allowedRoles={['admin']}><TrackingRewardsSettings /></RoleProtectedRoute>} />
                <Route path="/portal-settings/insurance" element={<RoleProtectedRoute allowedRoles={['admin']}><PortalInsuranceSettings /></RoleProtectedRoute>} />
                <Route path="/portal-settings/ai-assistant" element={<Navigate to="/settings/advanced?tab=ki-api" replace />} />
                <Route path="/portal-settings/google-oauth" element={<RoleProtectedRoute allowedRoles={['admin']}><GoogleOAuthSettingsPage /></RoleProtectedRoute>} />
                <Route path="/portal-settings/icloud-sync" element={<RoleProtectedRoute allowedRoles={['admin']}><ICloudSyncSettingsPage /></RoleProtectedRoute>} />
                <Route path="/portal-settings/embed" element={<RoleProtectedRoute allowedRoles={['admin']}><PortalEmbedSettings /></RoleProtectedRoute>} />
                <Route path="/mobile-app" element={<RoleProtectedRoute allowedRoles={['admin']}><MobileAppPage /></RoleProtectedRoute>} />
                <Route path="/health-dashboard" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><HealthDashboardPage /></RoleProtectedRoute>} />
                <Route path="/system-health" element={<RoleProtectedRoute allowedRoles={['admin']}><SystemHealthPage /></RoleProtectedRoute>} />
                <Route path="/audit-log" element={<RoleProtectedRoute allowedRoles={['admin']}><AuditLogPage /></RoleProtectedRoute>} />
                <Route path="/funnel-tracking" element={<RoleProtectedRoute allowedRoles={['admin']}><FunnelTrackingPage /></RoleProtectedRoute>} />
                <Route path="/crm" element={<RoleProtectedRoute allowedRoles={['admin']}><ModuleProtectedRoute module="crm"><CrmPipelinePage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/dental" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="dental_chart"><DentalChartPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/dental-perio" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="dental_chart"><DentalPerioPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/dental-recall" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="dental_recall"><DentalRecallPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/dental-billing" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="dental_billing"><DentalBillingPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/dental-estimates" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="dental_billing"><DentalEstimatesPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/dental-plans" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="dental_billing"><DentalTreatmentPlanPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/workshop" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><ModuleProtectedRoute module="workshop_orders"><WorkshopPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/timetracking" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer']}><TimeTrackingPage /></RoleProtectedRoute>} />
                
                {/* Customer Subscriptions Management */}
                <Route path="/customer-subscriptions" element={<RoleProtectedRoute allowedRoles={['admin']}><CustomerSubscriptionsPage /></RoleProtectedRoute>} />
                
                {/* Routes with permission-based access for trainers */}
                <Route path="/customers" element={<PermissionProtectedRoute allowedRoles={['admin', 'trainer']} requiredPermission="can_view_customers"><CustomersPage /></PermissionProtectedRoute>} />
                <Route path="/sales" element={<PermissionProtectedRoute allowedRoles={['admin', 'trainer']} requiredPermission="can_sell_packages"><SalesPage /></PermissionProtectedRoute>} />
                <Route path="/invoices" element={<PermissionProtectedRoute allowedRoles={['admin', 'superadmin']} requiredPermission="can_view_finances"><ModuleProtectedRoute module="invoicing"><InvoicesPage /></ModuleProtectedRoute></PermissionProtectedRoute>} />
                <Route path="/billing" element={<PermissionProtectedRoute allowedRoles={['admin', 'trainer']} requiredPermission="can_view_finances"><ModuleProtectedRoute module="invoicing"><BillingPage /></ModuleProtectedRoute></PermissionProtectedRoute>} />
                <Route path="/billing-audit" element={<RoleProtectedRoute allowedRoles={['admin']}><ModuleProtectedRoute module="invoicing"><BillingAuditPage /></ModuleProtectedRoute></RoleProtectedRoute>} />
                <Route path="/payments" element={<PermissionProtectedRoute allowedRoles={['admin', 'trainer']} requiredPermission="can_view_finances"><ModuleProtectedRoute module="invoicing"><PaymentsPage /></ModuleProtectedRoute></PermissionProtectedRoute>} />
                <Route path="/reports" element={<PermissionProtectedRoute allowedRoles={['admin', 'trainer']} requiredPermission="can_view_reports"><ReportsPage /></PermissionProtectedRoute>} />
                <Route path="/settings" element={<PermissionProtectedRoute allowedRoles={['admin', 'trainer']} requiredPermission="can_view_settings"><SettingsHub /></PermissionProtectedRoute>} />
                <Route path="/settings/:panelId" element={<PermissionProtectedRoute allowedRoles={['admin', 'trainer']} requiredPermission="can_view_settings"><SettingsHub /></PermissionProtectedRoute>} />
                <Route path="/settings/advanced" element={<PermissionProtectedRoute allowedRoles={['admin', 'trainer']} requiredPermission="can_view_settings"><SettingsPage /></PermissionProtectedRoute>} />
                <Route path="/settings/aenderungsprotokoll" element={<PermissionProtectedRoute allowedRoles={['admin', 'trainer']} requiredPermission="can_view_settings"><SettingsChangeLogPage /></PermissionProtectedRoute>} />
                
                {/* Admin and Trainer routes (default permission: calendar) */}
                <Route path="/appointments" element={<PermissionProtectedRoute allowedRoles={['admin', 'trainer']} requiredPermission="can_view_calendar"><ModuleProtectedRoute module="booking"><AppointmentsPage /></ModuleProtectedRoute></PermissionProtectedRoute>} />
                
                {/* Admin, Trainer and Mieter routes */}
                <Route path="/resources" element={<RoleProtectedRoute allowedRoles={['admin', 'trainer', 'mieter']}><ResourcesPage /></RoleProtectedRoute>} />
                
                {/* Public routes (still require login) */}
                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              </Routes>
            </DashboardLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <StudioProvider>
          <ModulesProvider>
          <BrowserRouter>
            <TenantBrandingProvider>
            <GlobalActivityBar />
            <SeriesJobsOverlay />
            <SupportModeBanner />
            <AppRoutes />
            <Toaster position="top-right" />
            <MaintenanceOverlay />
            </TenantBrandingProvider>
          </BrowserRouter>
          </ModulesProvider>
        </StudioProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
